// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

const PUBLISH_BASE_URL = '/api/v1/wechat/publish';

/**
 * 获取信息发布审批列表
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getPublishApplicationList(
  params: OA.PublishApplicationListParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.PublishApplicationListData>>(
    `${PUBLISH_BASE_URL}/applications`,
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}

/**
 * 导出信息审核表
 * @param spNo 审批单号
 * @param options 请求配置
 */
export async function exportPublishForm(
  spNo: string,
  options?: { [key: string]: any },
) {
  return request<Blob>(`${PUBLISH_BASE_URL}/export-form/${spNo}`, {
    method: 'GET',
    responseType: 'blob',
    ...(options || {}),
  });
}
